'use strict';

angular.module('atex.dam').directive('damTags', function() {
  return {
   
    restrict : 'E',
    
    templateUrl : 'views/dam-tag.html',
    
    replace : false,
    
    scope : {
      fieldModel : "=",
      label : "@",
      entries : "=",
      onChange: '&'
    },

    link : function(scope, element, attrs) {
      
      scope.field = {
          model : scope.fieldModel
      };
      
      scope.$watch(function(){
        return scope.field.model;
      }, function(newValue, oldValue) {
        scope.fieldModel = newValue;
      }, true);
      
      scope.$watch(function(){
        return scope.fieldModel;
      }, function(newValue, oldValue) {
        if (newValue===undefined) {
          newValue = [];
        }
        scope.field.model = newValue;
      }, true);
      
    }
    
  };
  
} );
